import React from "react";
import Wrapper from "../../../../_hoc/Wrapper";
import Basic from "./Basic";
import Physical from "./Physical";
import Education from "./Education";
import Family from "./Family";
import Habit from "./Habit";
import Astrology from "./Astrology";
// import AstrologyDetail from "../../../Profile/Home/ProfileInformation/AstrologyDetail";

const ProfileInformation = props => {
  return (
    <Wrapper>
      <Basic />
      <Physical />
      <Education />
      <Family />
      <Habit />
      <Astrology />
    </Wrapper>
  );
};

export default ProfileInformation;



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/index.js